import React from 'react'
import PropTypes from 'prop-types'

import {
  TIERED_INTERVENTION_PROGRAM_LIST,
  K5_PROGRAM_TYPE,
} from 'utils/program/types'

import BackLink from 'components/BackLink'
import BreadcrumbHeaderRow from 'components/BreadcrumbHeaderRow'
import SiteSelector from 'components/SiteSelector'
import TierLabel from 'components/TierLabel'
import { hasBreadcrumbLinks } from 'utils/breadcrumbHelpers'
import {
  HeaderWrapper,
  NavigationBar,
  BackLinkWrapper,
  SiteSelectorWrapper,
  HeaderContent,
  TierPill,
  Title,
  ProgressText,
  Description,
  TabNavigation,
  TabButton,
  HeaderImageBackground,
} from './component.styles'

const TieredInterventionsHeader = ({
  backLinkText,
  backLinkOnClick,
  breadcrumb,
  currentPageTitle,
  tierLabel,
  title,
  progressText,
  description,
  tabs = [],
  onTabChange,
  programType = K5_PROGRAM_TYPE,
}) => {
  return (
    <HeaderImageBackground programType={programType}>
      <HeaderWrapper programType={programType}>
        {hasBreadcrumbLinks(breadcrumb) ? (
          <BreadcrumbHeaderRow
            breadcrumb={breadcrumb}
            currentPageTitle={currentPageTitle}
            isLight
          >
            <SiteSelectorWrapper>
              <SiteSelector />
            </SiteSelectorWrapper>
          </BreadcrumbHeaderRow>
        ) : (
          <NavigationBar>
            <BackLinkWrapper>
              <BackLink onClick={backLinkOnClick}>{backLinkText}</BackLink>
            </BackLinkWrapper>
            <SiteSelectorWrapper>
              <SiteSelector />
            </SiteSelectorWrapper>
          </NavigationBar>
        )}
        <HeaderContent>
          <TierPill>
            <TierLabel labelText={tierLabel} />
          </TierPill>
          <Title>{title}</Title>
          {progressText && <ProgressText>{progressText}</ProgressText>}
          <Description>{description}</Description>
          <TabNavigation>
            {tabs.map((tab, index) => (
              <TabButton
                isActive={tab?.isActive}
                key={index}
                onClick={() => onTabChange(tab)}
              >
                {tab.title}
              </TabButton>
            ))}
          </TabNavigation>
        </HeaderContent>
      </HeaderWrapper>
    </HeaderImageBackground>
  )
}

TieredInterventionsHeader.propTypes = {
  backLinkOnClick: PropTypes.func.isRequired,
  backLinkText: PropTypes.string.isRequired,
  breadcrumb: PropTypes.object,
  currentPageTitle: PropTypes.string,
  description: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  programType: PropTypes.oneOf(TIERED_INTERVENTION_PROGRAM_LIST),
  progressText: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired,
    }),
  ),
  tierLabel: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default TieredInterventionsHeader
